import { Link } from "react-router-dom";
import { MessageCircle, Mail, CalendarCheck2, Phone } from "lucide-react";
import { CONTACT, PATOLOGIE, PRESTAZIONI } from "@/data/siteData";
import { FOOTER } from "@/constants/testIds";
import {
  trackBookingClick,
  trackWhatsappClick,
  trackEmailClick,
} from "@/lib/analytics";

export default function Footer() {
  const wa = `https://wa.me/39${CONTACT.whatsapp}`;

  return (
    <footer
      data-testid={FOOTER.root}
      className="relative bg-[#0B4A5A] text-white overflow-hidden"
    >
      <div className="gold-line absolute top-0 left-0 right-0" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-serif text-3xl leading-tight">
            Dr. Cristian Santus
          </div>
          <p className="text-[11px] uppercase tracking-[0.24em] text-[#C6A86B] mt-1">
            Gastroenterologo
          </p>
          <p className="mt-6 text-white/70 max-w-md leading-relaxed">
            La salute dell'apparato digerente merita attenzione, competenza e
            ascolto. Visite specialistiche, second opinion e percorsi di cura
            personalizzati.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a
              data-testid={FOOTER.book}
              href={CONTACT.miodottore}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackBookingClick("footer")}
              className="inline-flex items-center gap-2 bg-white text-[#0B4A5A] px-5 py-3 rounded-full text-sm font-medium hover:bg-[#F9FAFB] transition"
            >
              <CalendarCheck2 size={16} strokeWidth={1.6} />
              Prenota
            </a>
            <a
              data-testid={FOOTER.whatsapp}
              href={wa}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackWhatsappClick("footer")}
              className="inline-flex items-center gap-2 border border-white/25 px-5 py-3 rounded-full text-sm font-medium hover:border-white/60 transition"
            >
              <MessageCircle size={16} strokeWidth={1.6} />
              WhatsApp
            </a>
            <a
              data-testid={FOOTER.email}
              href={`mailto:${CONTACT.email}`}
              onClick={() => trackEmailClick("footer")}
              className="inline-flex items-center gap-2 border border-white/25 px-5 py-3 rounded-full text-sm font-medium hover:border-white/60 transition"
            >
              <Mail size={16} strokeWidth={1.6} />
              Email
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-white/95 uppercase tracking-[0.18em]">
            Prestazioni
          </h4>
          <ul className="mt-5 space-y-3">
            {PRESTAZIONI.slice(0, 6).map((p) => (
              <li key={p.slug}>
                <Link
                  to={`/prestazioni/${p.slug}`}
                  className="text-white/70 hover:text-[#C6A86B] transition text-sm"
                >
                  {p.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-white/95 uppercase tracking-[0.18em]">
            Patologie
          </h4>
          <ul className="mt-5 space-y-3">
            {PATOLOGIE.slice(0, 6).map((p) => (
              <li key={p.slug}>
                <Link
                  to={`/patologie/${p.slug}`}
                  className="text-white/70 hover:text-[#C6A86B] transition text-sm"
                >
                  {p.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/50">
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
            <span>
              © {new Date().getFullYear()} Dr. Cristian Santus — Tutti i diritti
              riservati.
            </span>
            <Link
              to="/privacy"
              data-testid="footer-privacy"
              className="text-white/60 hover:text-[#C6A86B] transition"
            >
              Privacy Policy
            </Link>
          </div>
          <div className="flex items-center gap-2">
            <Phone size={12} />
            <span>{CONTACT.whatsappDisplay}</span>
            <span className="mx-2">·</span>
            <span>{CONTACT.email}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
